<template>
  <div class="wait-pay" v-loading="loading" element-loading-text="数据加载中" v-cloak>
    <div class="wai-header">
      <div class="header-title">
        <i class="iconfont-erp icondaizhifu"></i> 待支付(<span>{{ TotalCount }}</span
        >)
      </div>
      <div class="header-icon">
        <i class="iconfont-erp icontongbu"></i>
      </div>
    </div>
    <ul class="pay-list" v-if="list.length">
      <li class="pay-haeder">
        <div class="offer-name">商品信息</div>
        <div class="offer-price">金额(元)</div>
      </li>
      <li class="pay-item" v-for="(item, index) in list" :key="index">
        <!-- v-if="!$store.getters.isNew" -->
        <a
          v-if="$store.getters.isNew"
          @click="gotoPay2(item.OrderNo, item.TotalAmount, item.OrderSign)"
          style="dispaly:inlie-block;cursor: pointer;"
        >
          <div class="offer-name">
            <p class=" dz-nowrap" style="padding-right:50px">
              {{ item.Offer[0].Subject }}
            </p>
          </div>
          <div class="offer-price">{{ item.TotalAmount | moneyFormat }}</div>
        </a>
        <a v-else @click="gotoPay(item.OrderNo)" style="dispaly:inlie-block;cursor: pointer;">
          <div class="offer-name">
            <p class=" dz-nowrap" style="padding-right:50px">
              {{ item.Offer[0].Subject }}
            </p>
          </div>

          <div class="offer-price">{{ item.TotalAmount | moneyFormat }}</div>
        </a>
      </li>
    </ul>
    <div class="empty-list" style="padding-top:40px;" v-if="!loading && list.length == 0">
      <i class="iconfont-erp iconjingshi"></i>暂无数据
    </div>
  </div>
</template>

<script>
import goToPayMixin from "../../order/mixins/goToPayMixin";
export default {
  mixins: [goToPayMixin],
  data() {
    return {
      TotalCount: 0,
      loading: true,
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      var that = this;
      that.$ajax
        .post("/api/Order/List", {
          Status: 1,
          PageIndex: 1,
          PageSize: 5,
        })
        .then((res) => {
          that.list = res.List;
          that.TotalCount = res.TotalCount;
          that.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.wait-pay {
  margin-top: 20px;
  padding: 15px;
  background-color: #fff;
}

.wai-header {
  overflow: hidden;
  padding: 0 10px 10px;

  .header-title {
    float: left;
    font-size: 16px;
    color: #333333;
    font-weight: bold;

    span {
      color: #0085fe;
    }
  }

  i {
    font-size: 18px;
    font-weight: normal;
  }

  .header-icon {
    float: right;
  }
}

.pay-list {
  font-size: 12px;

  li {
    line-height: 26px;
    padding: 0 10px;
  }

  .offer-name {
    width: 75%;
  }

  .offer-price {
    width: 25%;
    text-align: right;
  }

  .item-btn {
    text-align: right;
    width: 10%;

    a {
      color: #0085fe;
    }
  }
}

.pay-haeder {
  color: #999;
  overflow: hidden;

  > div {
    float: left;
  }
}

.pay-item {
  overflow: hidden;
  a {
    width: 100%;
    display: flex;
    flex-direction: row;
  }
  &:hover a,
  &:hover p {
    color: #09f;
    // background: #f6faff;
  }

  > div {
    float: left;
  }
}
</style>
